<template lang="pug">
  article.accordion(:class="{ 'is-active':state, 'is-disabled': disabled}" @mouseover="inFocus" @mouseleave="outFocus")
    .accordion-header(@click="toogleAccordion()")
      p {{ title }}
    .accordion-body(v-show="state")
      .accordion-content
        slot
          .loading-wrap
            loading(:size="'26px'")
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { gettext } from '@/services/TranslateHandler'
import VTooltip from 'v-tooltip'
import {Diamond as Loading} from 'vue-loading-spinner'

const _ = require('lodash')

Vue.use(VTooltip, {
  defaultTrigger: 'manual'
})

export default {
  name: 'Accordion',
  components: {
    Loading
  },
  props: {
    title: {
      default: ''
    },
    disabled: {
      default: false
    },
    loadOpened: {
      default: false
    }
  },
  data () {
    return {
      state: false
    }
  },
  methods: {
    gettext: gettext,
    toogleAccordion: function () {
      this.$emit('click')
      if (!this.disabled) {
        this.switch()
      }
    },
    inFocus () {
      if (this.state) {
        this.$emit('active', true)
      }
    },
    outFocus () {
      setTimeout(() => {
        this.$emit('unactive', true)
      }, 5000)
    },
    switch (status) {
      if (_.isBoolean(status)) this.state = status
      else this.state = !this.state
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ])
  },
  watch: {
    state: function (val) {
      if (val) {
        this.$emit('opened')
      } else {
        this.$emit('unactive', true)
        this.$emit('closed')
      }
    },
    disabled: function (val) {
      if (!val) this.$emit('ready')
      else this.state = false
    }
  },
  created () {
    if (this.loadOpened) {
      this.state = true
    }
    this.$bus.$on('accordion_close', (status) => {
      this.state = !status
    })
  }
}
</script>

<style lang='scss' scoped>
  .accordions {
    margin-bottom: 30px;
    .accordion {
      border: 1px solid #c7c7c7;
      border-bottom: none!important;
      &.is-disabled{
        cursor: help;
        opacity: 0.5;
        .accordion-header{
          cursor: help;
        }
      }
      &:last-child {
        border-bottom: 1px solid #c7c7c7;
      }
      &.is-active {
        .accordion-header {
          &:after {
            top: 16px;
            border-top: none;
            border-bottom: 6px solid #c7c7c7;
          }
        }
      }
      .accordion-header {
        position: relative;
        padding: 10px 20px 10px 15px;
        cursor: pointer;
        &:after {
          content: '';
          position: absolute;
          right: 10px;
          top: 18px;
          border: 3.5px solid transparent;
          border-top: 6px solid #c7c7c7;
        }
        p {
          color: #414042;
          font-size: 14px;
          font-weight: 500;
          letter-spacing: 0.14px;

        }
      }
      .accordion-body {
        padding: 0 15px 5px 15px;
        font-size: 14px;
      }
    }
    .loading-wrap{
      display: flex;
      justify-content: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/accordion/index.vue